import { render, staticRenderFns } from "./photo-upload.html?vue&type=template&id=440000b9&"
import script from "./photo-upload.js?vue&type=script&lang=js&"
export * from "./photo-upload.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports